<template>
  <div class="store-contain">
    <div class="store-contain-title">终端门店价值体系</div>
    <div class="store-card-container">
      <div
        class="store-card"
        v-for="(item, index) in cardList"
        :key="index"
        :class="{ active: activeIndex === index }"
        @mouseenter="activeIndex = index"
      >
        <div
          class="card-title-bg"
          :style="{ backgroundImage: `url(${item.titlebgimg})` }"
        >
          <div class="card-header">
            <h2 class="card-title">{{ item.title }}</h2>
            <p class="card-title-des">{{ item.titleDes }}</p>
          </div>
        </div>

        <div
          class="card-features-bg"
          :style="{ backgroundImage: `url(${item.featuresbgimg})` }"
          v-if="activeIndex === index"
        >
          <div class="card-content">
            <div class="feature-item">
              <h3 class="feature-level1Heading">{{ item.level1Heading }}</h3>
              <p class="feature-level2Heading">{{ item.level2Heading }}</p>
              <p class="feature-content">{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "storeCardSwitch",
  data() {
    return {
      activeIndex: 0,
      cardList: [
        {
          title: "便捷下单",
          titleDes: "下单智能便捷，体验个性精准",
          titlebgimg: "https://ztc-obs.zgztc.cn/2025/12/25/b3a8b4cb-5c6f-4794-ad23-4a35f27e179e.png",
          featuresbgimg: 'https://ztc-obs.zgztc.cn/2025/12/25/2a0e069e-dc87-4919-bd3e-28880694f7f2.png',
          level1Heading: "便捷下单",
          level2Heading: "下单智能便捷，体验个性精准",
          content:
            "平台深度适配终端门店采购习惯，持续优化下单流程与界面交互。AI智能寻品与推荐功能助力门店精准选品、高效下单，实现个性化采购体验",
        },
        {
          title: "源头直供",
          titleDes: "品牌源头直供，品类丰富齐全",
          titlebgimg:"https://ztc-obs.zgztc.cn/2025/12/25/c6e4e1a2-a160-43f8-8ce4-d8aeaf91ea9c.png",
          featuresbgimg: "https://ztc-obs.zgztc.cn/2025/12/25/7c4e643e-7d0e-4b44-a5fa-39f4b69e5f72.png",
          level1Heading: "源头直供",
          level2Heading: "品牌源头直供，品类丰富齐全",
          content:
            "平台联合行业高端品牌建立源头直供合作，依托全国供应链资源，持续拓展商品品类，助力门店一站式购齐，构建稳定、优质的货源竞争力",
        },
        {
          title: "价格稳健",
          titleDes: "价格体系稳健，营销提振效益",
          titlebgimg: "https://ztc-obs.zgztc.cn/2025/12/25/d1f0d557-24dc-44bd-a13c-85dfd7ef66b7.png",
          featuresbgimg: "https://ztc-obs.zgztc.cn/2025/12/25/fbbf4070-383c-4924-8a20-8e0e403ab880.png",
          level1Heading: "价格稳健",
          level2Heading: "价格体系稳健，营销提振效益",
          content:
            "平台产品价格优势显著，并结合专属营销活动与积分福利，助力门店有效控制成本、提升经营效益",
        },
        {
          title: "高效配送",
          titleDes: "配送高效到店，支付灵活自主",
          titlebgimg: "https://ztc-obs.zgztc.cn/2025/12/25/a422f3ff-50db-42d1-bb59-93940d2b1161.png",
          featuresbgimg:  "https://ztc-obs.zgztc.cn/2025/12/25/750610bd-e33f-4d6d-810b-3ba4c2529f5a.png",
          level1Heading: "高效配送",
          level2Heading: "配送高效到店，支付灵活自主",
          content:
            "依托区域服务商本地仓储物流网络，实现订单快速精准配送。同步支持多种灵活支付方式，减轻资金压力，真正实现零库存、轻运营",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.store-contain {
  width: 1170px;
  margin: 100px auto;
  .store-contain-title {
    height: 48px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 48px;
    color: #000000;
    line-height: 48px;
    text-align: center;
    margin-bottom: 70px;
  }

  .store-card-container {
    display: flex;
    gap: 0;
    overflow: hidden;

    .store-card {
      position: relative;
      width: 180px;
      height: 460px;
      flex-shrink: 0;
      transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
      cursor: pointer;
      overflow: hidden;
      margin-left: 15px;

      &.active {
        width: 585px;
      }

      .card-title-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 180px;
        height: 460px;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        box-sizing: border-box;
        z-index: 1;
        transition: opacity 0.8s ease;

        .card-header {
          padding: 30px 25px;

          .card-title {
            height: 31px;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 24px;
            color: #3e3e3e;
            line-height: 31px;
          }

          .card-title-des {
            margin-top: 10px;
            height: 48px;
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #585f65;
            line-height: 24px;
          }
        }
      }

      &.active .card-title-bg {
        opacity: 0;
        pointer-events: none;
      }

      .card-features-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 585px;
        height: 460px;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        padding: 35px;
        box-sizing: border-box;
        z-index: 2;
        opacity: 0;
        transform: translateX(-20px);
        transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) 0.1s;

        .card-content {
          color: #fff;
          height: 100%;
          position: relative;

          .feature-item {
            margin-bottom: 25px;

            .feature-level1Heading {
              height: 31px;
              font-family: MicrosoftYaHei, MicrosoftYaHei;
              font-weight: bold;
              font-size: 24px;
              color: #ffffff;
              line-height: 31px;
              margin-bottom: 10px;
            }

            .feature-level2Heading {
              height: 24px;
              font-family: MicrosoftYaHei, MicrosoftYaHei;
              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              line-height: 24px;
            }

            .feature-content {
              margin-top: 25px;
              font-family: MicrosoftYaHei;
              font-size: 16px;
              color: #ffffff;
              line-height: 24px;
            }
          }
        }
      }

      &.active .card-features-bg {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .store-card:nth-child(1) {
      margin-left: 0;
    }

    // @media (max-width: 768px) {
    //   flex-wrap: wrap;
    //   padding: 0 10px;

    //   .store-card {
    //     width: 100%;
    //     height: 200px;
    //     margin-bottom: 10px;

    //     &.active {
    //       width: 100%;
    //       height: 400px;
    //     }

    //     .card-title-bg,
    //     .card-features-bg {
    //       width: 100%;
    //       height: 100%;
    //     }
    //   }
    // }
  }
}
</style>
